import type { ReactElement, ReactNode } from 'react';
import BevSafeText from '../../../bev-safe-text';

export type AvailabilityMessageProps = {
	title?: string;
	subTitle?: string;
	children?: ReactNode;
};

/** Simple stub for `ProductAvailabilityMessage.tsx` - used for the "no availability" / "sold out"
 * fallback states. */
export default function AvailabilityMessage({
	title,
	subTitle,
	children,
}: AvailabilityMessageProps): ReactElement {
	return (
		<div
			className="flex flex-col items-center gap-100 py-300 text-center"
			data-testid="availability-message"
		>
			{title && (
				<span className="text-subtitle2 text-text-heading">
					<BevSafeText>{title}</BevSafeText>
				</span>
			)}
			{subTitle && (
				<span className="text-body3 text-text-secondary">
					<BevSafeText>{subTitle}</BevSafeText>
				</span>
			)}
			{children}
		</div>
	);
}
